<template>
  <div>
    <nav-bar />
    <div class="tousuMain">
      <h3 v-html="TousuMain.comtitle"></h3>
      <div class="tsr">
        <span>投诉人：{{ TousuMain.aname }}</span>
        <span>{{ TousuMain.createtime }}</span>
        <span>阅读量：{{ TousuMain.viewnum }}</span>
      </div>
      <div class="content">
        <p>投诉公司：{{ TousuMain.comobj }}</p>
        <p>所在地区：{{ TousuMain.aaddr }}</p>
        <div class="text">
          <p v-html="TousuMain.comcontent"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/common/Navbar.vue";

export default {
  name: "",
  components: {
    NavBar
  },
  props: {},
  data() {
    return {
      TousuMain: ""
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getTousuList();
  },
  mounted() {},
  methods: {
    async getTousuList() {
      const res = await this.$http.get(
        "/home/api/gettsmain?id=" + this.$route.query.id
      );
      console.log(res.data);
      this.TousuMain = {
        comlabel: res.data.comlabel,
        aname: res.data.aname,
        comtitle: res.data.comtitle,
        createtime: res.data.createtime,
        viewnum: res.data.viewnum,
        comobj: res.data.comobj,
        aaddr: res.data.aaddr,
        comcontent: res.data.comcontent,
        id: res.data.id
      };
    }
  }
};
</script>

<style scoped lang="scss">
.tousuMain {
  margin-top: 48px;
  padding: 10px;
  background: #fff;
  h3 {
    margin: 0;
    font-size: 16px;
    line-height: 32px;
  }
  .tsr {
    border-bottom: 1px solid #eee;
    padding-bottom: 6px;
    span {
      font-size: 12px;
      color: #999;
      margin-right: 10px;
    }
  }
  .content {
    p {
      font-size: 12px;
      margin-top: 5px;
      color: #999;
    }
    .text {
      p {
        font-size: 14px;
        color: #333;
        line-height: 18px;
      }
    }
  }
}
</style>
